import React, { useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import HeaderTab from 'routes/home/components/desktop/HeaderTabV2';
import Cookie from 'utils/cookies';
import Link from 'components/Link';
import makeRequest from 'utils/makeRequest';
import { TOI_LIVE_DOMAIN } from 'constants/index.js';
// import { UNIFIED_FEED_DOMAIN } from '../../../constants';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import s from './SunSignsWidget.scss';

const PrevArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button
      aria-label="Slide Left"
      {...sliderProps}
      className={`${s.arrows} ${s.left} ${className}`}
    />
  );
};

const NextArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button
      aria-label="Slide Right"
      {...sliderProps}
      className={`${s.arrows} ${s.right} ${className}`}
    />
  );
};

const SunSignsWidget = props => {
  const {
    isWapView,
    title,
    isRHSWidget,
    isRHSWidgetMobile,
    disablePinnedFeature,
    items,
    dataUrl,
    nav,
    id,
    wrapperclass,
    promoData,
    pageUrl,
  } = props;

  const sunsignLandingPage = !!(
    nav?.subsec1?.subsecmsid1 === '65857041' &&
    nav?.subsec2?.subsecmsid2 === '74943709' &&
    nav?.subsec3?.subsecmsid3 &&
    id !== 'sunsignsubpages'
  );
  let sunsignPageName = '';
  let sunsignSubPageName = '';

  // let sunsignLandingPageName = nav?.subsec3?.subsecname3;
  const [sunsignLandingPageName, setsunsignLandingPageName] = useState(
    nav?.subsec3?.subsecname3,
  );
  const sliderCond = sunsignLandingPage && id !== 'sunsign_personality_traits';
  const slideToscroll = sliderCond ? 6 : 8;
  const slideToshow = sliderCond ? 6 : 4;
  const slideToscrollsmall = sliderCond ? 5 : 7;
  const slideToshowsmall = sliderCond ? 1 : 5;

  const settings = {
    slidesToShow: isRHSWidget ? 3 : slideToscroll,
    slidesToScroll: isRHSWidget ? 3 : slideToshow,
    variableWidth: true,
    arrows: true,
    dots: true,
    infinite: false,
    dotsClass: s.dots,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1510,
        settings: {
          slidesToShow: isRHSWidget ? 3 : slideToscrollsmall,
          slidesToScroll: isRHSWidget ? 3 : slideToshowsmall,
        },
      },
    ],
  };
  const pinnedZodiacCookieName = 'pinnedZodiac';
  const initialZodiacSigns = [
    'aries',
    'taurus',
    'gemini',
    'cancer',
    'leo',
    'virgo',
    'libra',
    'scorpio',
    'sagittarius',
    'capricorn',
    'aquarius',
    'pisces',
  ];
  const headerTabs = [
    { name: 'daily', path: '/' },
    { name: 'weekly', path: '/' },
    { name: 'monthly', path: '/' },
    { name: 'yearly', path: '/' },
    { name: 'characteristics', path: '/' },
  ];

  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.pathname
  ) {
    const sections = window?.location?.pathname.split('/');
    if (sections && Array.isArray(sections) && sections.length > 2) {
      sunsignPageName = initialZodiacSigns.findIndex(
        obj => obj === sections[sections.length - 2],
      );
      sunsignSubPageName = headerTabs.findIndex(
        obj => obj.name === sections[sections.length - 1],
      );
    }
  }
  const pinnedZodiacCookie = Cookie.get(pinnedZodiacCookieName);

  const sliderRef = useRef(null);

  const [pinnedZodiac, setPinnedZodiac] = useState(
    id && id === 'sunsignsubpages' ? null : pinnedZodiacCookie,
  );
  const [hidePinnedText, setHidePinnedText] = useState(
    id === 'sunsignsubpages',
  );
  const [successMessage, setSuccessMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [activeTab, setActiveTab] = useState(headerTabs[0].name);
  const [sunsignData, setData] = useState(undefined);
  const [dynamicLink, setDynamicLink] = useState('');
  const [readMoreLink, setReadMoreLink] = useState('');

  const pinText = 'Pin this Zodiac';
  const insteadPinText = 'Pin this instead';
  const unpinText = 'Unpin this zodiac';
  const unSelectedPinnedText = pinnedZodiac ? insteadPinText : pinText;

  const [zodiacSigns, setZodiacSigns] = useState(initialZodiacSigns);
  const [selectedZodiac, setSelectedZodiac] = useState(
    pinnedZodiac || zodiacSigns[0],
  );

  const onTabsChange = dataObj => {
    setActiveTab(dataObj?.clickedItem?.name);
  };

  useEffect(() => {
    if (id && id === 'sunsignsubpages') {
      setSelectedZodiac(initialZodiacSigns[sunsignPageName]);
      setActiveTab(headerTabs[sunsignSubPageName]?.name);
    }
    if (id === 'sunsign_personality_traits') {
      setsunsignLandingPageName('');
    }
  }, []);

  const onZodiacSignChange = zodiac => {
    if (zodiac !== selectedZodiac) {
      setSelectedZodiac(zodiac);
      setSuccessMessage('');
      if (
        (id && id === 'sunsign_widget') ||
        (pageUrl &&
          typeof pageUrl === 'string' &&
          !(
            pageUrl.includes('daily') ||
            pageUrl.includes('weekly') ||
            pageUrl.includes('monthly')
          ))
      ) {
        setHidePinnedText(false);
        const updatedUrl = `/astrology/horoscope/${zodiac}`;
        window.history.pushState({ map: 'some_state' }, '', updatedUrl);
      }
    }
  };

  const unpinZodiac = () => {
    setHidePinnedText(true);
    setSuccessMessage('Successfully Unpinned');

    setPinnedZodiac(undefined);

    if (sliderRef && sliderRef.current) {
      if (!isWapView && sliderRef.current.slickGoTo) {
        sliderRef.current.slickGoTo(0);
      }
      if (isWapView) {
        sliderRef.current.scrollLeft = 0;
      }
    }

    setTimeout(() => {
      setSuccessMessage('');
      setHidePinnedText(false);
    }, 3000);

    setTimeout(() => {
      Cookie.remove(pinnedZodiacCookieName, '/');
    }, 0);
  };

  const pinZodiac = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowInfo(false);
    setHidePinnedText(true);
    setSuccessMessage('Successfully Pinned');
    setPinnedZodiac(selectedZodiac);

    if (sliderRef && sliderRef.current) {
      if (!isWapView && sliderRef.current.slickGoTo) {
        sliderRef.current.slickGoTo(0);
      }
      if (isWapView) {
        sliderRef.current.scrollLeft = 0;
      }
    }

    setTimeout(() => {
      setSuccessMessage('');
      setHidePinnedText(false);
    }, 3000);
    setTimeout(() => {
      Cookie.set(pinnedZodiacCookieName, selectedZodiac, 365, '/');
    }, 0);
  };

  const infoToggle = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowInfo(!showInfo);
  };

  const getPinnedTextHtml = () => {
    const infoHTML = (
      <>
        {showInfo && (
          <div className={s.tooltip_wrap}>
            <div className={s.tooltip}>
              <div>Quick Tip:</div>
              Pinned zodiac will be shown as your default zodiac & your
              preference will be saved for future horoscopes
            </div>
          </div>
        )}
      </>
    );
    return (
      <>
        {!hidePinnedText && (
          <>
            {pinnedZodiac && selectedZodiac === pinnedZodiac ? (
              <div className={`${s.pin}`} onClick={unpinZodiac}>
                <i /> {unpinText}
              </div>
            ) : (
              <div className={`${s.pin} ${s.pinned}`} onClick={pinZodiac}>
                <i /> {unSelectedPinnedText}
                {isWapView ? (
                  <span onClick={infoToggle}>{infoHTML}</span>
                ) : (
                  <span
                    onMouseEnter={infoToggle}
                    onMouseLeave={infoToggle}
                    onClick={event => {
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                  >
                    {infoHTML}
                  </span>
                )}
              </div>
            )}
          </>
        )}
        {successMessage && (
          <div className={`${s.pin} ${s.success}`}>
            <i /> {successMessage}
          </div>
        )}
      </>
    );
  };

  const rearrangeZodiacSigns = (newZodiac, zodiacSignsList) => {
    const filteredZodiacSigns = zodiacSignsList.filter(
      sign => sign !== pinnedZodiac,
    );
    return [newZodiac, ...filteredZodiacSigns];
  };

  useEffect(
    () => {
      if (Array.isArray(initialZodiacSigns) && initialZodiacSigns.length > 0) {
        // Move pinnedZodiac to the first position in the array
        if (pinnedZodiac) {
          if (
            id !== 'sunsign_personality_traits' &&
            props.name !== 'Read About Other Sun Signs'
          ) {
            const updatedZodiacSigns = rearrangeZodiacSigns(
              pinnedZodiac,
              initialZodiacSigns,
            );
            setZodiacSigns(updatedZodiacSigns);
          }
        }
        // Reorder to initial order if pinned zodiac is removed
        if (!pinnedZodiac && id !== 'sunsignsubpages') {
          setZodiacSigns(initialZodiacSigns);
          setSelectedZodiac(initialZodiacSigns[0]);
        }
      }
    },
    [pinnedZodiac],
  );

  useEffect(() => {
    if (!items && dataUrl) {
      const url = dataUrl;
      makeRequest.get(url, {}, 'skipfeedengine').then(response => {
        if (response && response.data && response.data.zodiacSigns) {
          setData(response.data.zodiacSigns);
        }
      });
    }
  }, []);

  // eslint-disable-next-line no-unused-vars
  const loaderComp = (
    <div className={`${s.sun_signs_wrap} ${isRHSWidget ? 'rhs_wrapper' : ''}`}>
      <LoaderSpinner />
    </div>
  );
  const data = items || sunsignData;
  let mainComp;
  const getDynamicPath = () => {
    if (activeTab === 'characteristics') {
      setDynamicLink(
        `${TOI_LIVE_DOMAIN}/astrology/horoscope/${selectedZodiac}`,
      );
    } else if (activeTab === 'yearly') {
      setDynamicLink(data[selectedZodiac][activeTab].wu);
    } else {
      setDynamicLink(
        `${TOI_LIVE_DOMAIN}/astrology/horoscope/${selectedZodiac}/${activeTab}`,
      );
    }
  };

  useEffect(
    () => {
      getDynamicPath();
      if (
        data &&
        data[selectedZodiac] &&
        data[selectedZodiac][activeTab] &&
        data[selectedZodiac][activeTab].wu
      ) {
        setReadMoreLink(data[selectedZodiac][activeTab].wu);
      }
    },
    [selectedZodiac, pinnedZodiac, activeTab],
  );

  const Wrapper = sunsignLandingPage ? Link : 'div';
  mainComp =
    data && Object.keys(data).length > 0 ? (
      <div
        className={`${s.sun_signs_wrap} sun_signs_wrap ${
          isRHSWidget ? 'rhs_wrapper' : ''
        } ${isRHSWidgetMobile ? s.rhs_wrapper_mweb : ''} `}
      >
        <div className={s.sun_signs_wrapper}>
          {!(isWapView || isRHSWidget) &&
            !sunsignLandingPage && (
              <Listingheader
                headingname="Horoscope"
                headingLink="/astrology/horoscope"
                isArrowNotNeeded
              >
                {headerTabs && headerTabs instanceof Array ? (
                  <HeaderTab
                    active={activeTab}
                    subSections={headerTabs}
                    onChangeCallback={onTabsChange}
                    contentWraperClass="sunsign_tabs_wrapper"
                  />
                ) : null}
              </Listingheader>
            )}

          {!isRHSWidget && sunsignLandingPage && <h3>{props.name}</h3>}
          {isRHSWidget &&
            !sunsignLandingPage && (
              <Link className={s.headingLink} to="/astrology/horoscope">
                {props.name || 'Horoscope'}
              </Link>
            )}
          {isWapView &&
            !isRHSWidget && (
              <Link className={s.headingLink} to="/astrology/horoscope">
                {props.name || 'Horoscope'}
              </Link>
            )}

          <div
            className={`${s.sun_signs_slider} `}
            ref={isWapView ? sliderRef : null}
          >
            {!isWapView ? (
              <div
                className={
                  sunsignLandingPage || !isRHSWidget
                    ? 'slick_UI'
                    : 'slick_UI smallArrow smallArrowBlack'
                }
              >
                <Slider ref={sliderRef} {...settings}>
                  {zodiacSigns.map(zodiac => (
                    <>
                      <Wrapper
                        className={`${s.sun_sign} ${s.subpage_wrap} ${
                          zodiac === selectedZodiac && !sunsignLandingPage
                            ? s.selected
                            : ''
                        } ${
                          zodiac === pinnedZodiac && id !== 'sunsignsubpages'
                            ? s.pinned_state
                            : ''
                        }`}
                        onClick={() => onZodiacSignChange(zodiac)}
                        key={zodiac}
                        to={
                          sunsignLandingPageName &&
                          sunsignLandingPageName?.toLowerCase() === zodiac
                            ? // eslint-disable-next-line no-script-url
                              'javascript:void(0);'
                            : `${TOI_LIVE_DOMAIN}/astrology/horoscope/${zodiac}`
                        }
                      >
                        <div className={`${s.sign_images} ${s[zodiac]}`}>
                          <i />
                        </div>
                        <div className={s.sign_name}>{zodiac}</div>
                        {data[zodiac] &&
                          data[zodiac].dateRange && (
                            <div className={s.date}>
                              {data[zodiac].dateRange}
                            </div>
                          )}
                      </Wrapper>
                      {zodiac === pinnedZodiac &&
                        !sunsignLandingPage &&
                        id !== 'sunsignsubpages' && (
                          <div className={`${s.pin} ${s.pinned}`}>
                            <i /> Pinned
                          </div>
                        )}
                    </>
                  ))}
                </Slider>
              </div>
            ) : (
              zodiacSigns.map(zodiac => (
                <div className={s.zodiac_wrap}>
                  <div
                    className={`${s.sun_sign} ${
                      selectedZodiac === zodiac ? s.selected : ''
                    } ${
                      zodiac === pinnedZodiac && id !== 'sunsignsubpages'
                        ? s.pinned_state
                        : ''
                    }`}
                    onClick={() => onZodiacSignChange(zodiac)}
                    key={zodiac}
                  >
                    <div className={`${s.sign_images} ${s[zodiac]}`}>
                      <i />
                    </div>
                    <div className={s.sign_name}>{zodiac}</div>
                    {data[zodiac] &&
                      data[zodiac].dateRange && (
                        <div className={s.date}>{data[zodiac].dateRange}</div>
                      )}
                  </div>
                  {zodiac === pinnedZodiac &&
                    id !== 'sunsignsubpages' && (
                      <div className={`${s.pin} ${s.pinned}`}>
                        <i /> Pinned
                      </div>
                    )}
                </div>
              ))
            )}
          </div>

          {(isWapView || isRHSWidget) && (
            <>
              {headerTabs && headerTabs instanceof Array ? (
                <HeaderTab
                  active={activeTab}
                  subSections={headerTabs}
                  onChangeCallback={onTabsChange}
                  contentWraperClass="sunsign_tabs_wrapper"
                />
              ) : null}
            </>
          )}
        </div>

        {!sunsignLandingPage && (
          <div className={s.sign_description}>
            <div className={s.head}>
              <Link className={s.date_name} to={dynamicLink}>
                {activeTab === 'characteristics' ? (
                  `${activeTab} of ${selectedZodiac}`
                ) : (
                  <>
                    <span>{selectedZodiac}</span> {`${activeTab} Horoscope`}
                  </>
                )}
              </Link>
              {!disablePinnedFeature ? getPinnedTextHtml() : null}
              {/* {selectedZodiac && (
            <a
              href={`https://timesofindia.indiatimes.com/astrology/zodiacs-astrology/${selectedZodiac}`}
              className={s.explore}
            >
              Explore Zodiac
            </a>
          )} */}
            </div>
            <div
              className={s.desc}
              key={`${selectedZodiac}-${activeTab}-description`}
            >
              {data[selectedZodiac] &&
              data[selectedZodiac][activeTab] &&
              typeof data[selectedZodiac][activeTab].description ===
                'string' ? (
                <>
                  {data[selectedZodiac][activeTab].description.substring(
                    0,
                    380,
                  )}
                  {readMoreLink && (
                    <Link
                      key={`${selectedZodiac}-${activeTab}-readmorelink`}
                      to={readMoreLink || data[selectedZodiac][activeTab].wu}
                      className={s.read_more_btn}
                      target="_blank"
                    >
                      Read More
                    </Link>
                  )}
                </>
              ) : null}
            </div>
            <div className={s.bottom_actns}>
              {!disablePinnedFeature ? getPinnedTextHtml() : null}
              {/* <a href="/" className={s.explore}>
            Explore Zodiac
          </a> */}
            </div>
            {promoData &&
              Array.isArray(promoData) &&
              promoData.length > 0 && (
                <div className={s.promtion_link_container}>
                  {promoData.map((item, index) => (
                    <Link
                      to={item.overridelink}
                      key={index}
                      className={s.pl_item}
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              )}
          </div>
        )}
      </div>
    ) : null;

  const sunsignPageMobileView = isWapView &&
    sunsignLandingPage &&
    data &&
    Object.keys(data).length > 0 && (
      <div
        className={`${wrapperclass ? s.sunsign_wrap : ''} ${
          s.sun_signs_wrap
        } sun_signs_wrap sun_signs_mweb ${isRHSWidget ? 'rhs_wrapper' : ''} ${
          isRHSWidgetMobile ? s.rhs_wrapper_mweb : ''
        } `}
      >
        <div className={s.sun_signs_wrapper}>
          {!isRHSWidget && sunsignLandingPage && <h3>{props.name}</h3>}
          <div
            className={s.sun_signs_slider}
            ref={isWapView ? sliderRef : null}
          >
            {zodiacSigns.map(zodiac => (
              <div className={s.zodiac_wrap}>
                <Link
                  className={`${s.sun_sign}`}
                  onClick={() => onZodiacSignChange(zodiac)}
                  key={zodiac}
                  to={
                    sunsignLandingPageName &&
                    sunsignLandingPageName?.toLowerCase() === zodiac
                      ? // eslint-disable-next-line no-script-url
                        'javascript:void(0);'
                      : `${TOI_LIVE_DOMAIN}/astrology/horoscope/${zodiac}`
                  }
                >
                  <div className={`${s.sign_images} ${s[zodiac]}`}>
                    <i />
                  </div>
                  <div className={s.sign_name}>{zodiac}</div>
                  {data[zodiac] &&
                    data[zodiac].dateRange && (
                      <div className={s.date}>{data[zodiac].dateRange}</div>
                    )}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );

  mainComp = isWapView && sunsignLandingPage ? sunsignPageMobileView : mainComp;

  return (
    <>
      {!data ? '' : mainComp}
      {title && <h1 className={s.h1tag}>{title.replace(/-/g, ' ')}</h1>}
    </>
  );
};

export default SunSignsWidget;
